@if (all === selected) {
  <span
    (click)="toggle(false)"
    >
    {{ 'theme.select-all.deselect_all' | translate }}
  </span>
}
@if (selected < all) {
  <span
    (click)="toggle(true)"
    >
    {{ 'theme.select-all.select_all' | translate }}
  </span>
}
